import { Color, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const ReconciliationSuggestionLineWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: ${Spacing.S8} ${Spacing.S16};
  border-radius: 8px;
  background-color: ${Color.White};
  ${getShadow('raisedLight')};
`

export const ReconciliationSuggestionDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`
